import { action, makeObservable, observable, runInAction } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import ArtistUploadViewStore from "application/producer/stores/upload/ArtistUploadViewStore";

class ProducerUploadContentViewStore extends MrbBaseViewStore {
    @observable producers = [];
    @observable selectedProducerId = null;

    _formStateByProducer = new Map();

    constructor(rootStore, { routeStore }) {
        super(rootStore);
        makeObservable(this);
        this.routeStore = routeStore;
        this.artistUploadViewStore = new ArtistUploadViewStore(rootStore, { routeStore });
    }

    async onInit() {
        try {
            const producers = await this.routeStore.getProducers();
            runInAction(() => {
                this.producers = producers || [];
                if (this.producers.length > 0) {
                    const parentSelectedId = this.rootStore.producerPreviewViewStore?.selectedProducerId;
                    const initialId =
                        parentSelectedId && this.producers.some((p) => p.id === parentSelectedId)
                            ? parentSelectedId
                            : this.producers[0].id;
                    this.selectedProducerId = initialId;
                    this.artistUploadViewStore.producerId = initialId;
                }
            });
            if (this.artistUploadViewStore.producerId) {
                await this.artistUploadViewStore.initialize();
            }

            this.reaction(
                () => this.rootStore.producerPreviewViewStore?.selectedProducerId,
                (newId) => { if (newId) this.selectProducer(newId); }
            );
        } catch (_) {}
    }

    @action.bound
    async selectProducer(producerId) {
        if (producerId === this.selectedProducerId) return;
        this.rootStore.producerPreviewViewStore?.setSelectedProducerId(producerId);

        if (this.selectedProducerId && this.artistUploadViewStore.phase === "idle") {
            this._formStateByProducer.set(this.selectedProducerId, {
                artistName: this.artistUploadViewStore.artistName,
                albumName: this.artistUploadViewStore.albumName,
                description: this.artistUploadViewStore.description,
                files: this.artistUploadViewStore.files.slice(),
            });
        }
        this.selectedProducerId = producerId;
        this.artistUploadViewStore.producerId = producerId;
        await this.artistUploadViewStore.initialize();

        runInAction(() => {
            if (this.artistUploadViewStore.phase === "pending") {
                return;
            }
            const saved = this._formStateByProducer.get(producerId);
            if (saved) {
                this.artistUploadViewStore.restoreState(saved);
            } else if (this.artistUploadViewStore.phase !== "result") {
                this.artistUploadViewStore.reset();
            }
        });
    }
}

export default ProducerUploadContentViewStore;
